import { Button, Col, Form, Input, Row, Select } from 'antd'
import type { FormInstance } from 'antd/es/form/Form'
import { useEffect, useMemo, useState } from 'react'
import { getCorporateGroups } from 'services/corporateGroup.service'

import ContentPanel from 'components/common/panel/PanalContent'
import { getAddress } from 'services/common.service'

const { Option } = Select
interface IProps {
  form: FormInstance
  corporateId?: string | number | undefined
}

const FormManageCorporate = ({ form, corporateId }: IProps) => {
  const [corporateGroup, setCorporateGroup] = useState<any>([])
  const [address, setAddress] = useState<any>([])
  const [districts, setDistricts] = useState<any>([])
  const [subDistricts, setSubDistricts] = useState<any>([])

  useEffect(() => {
    getCorporateGroupList()
    findAddress()
  }, [])

  const getCorporateGroupList = async () => {
    const payload = await getCorporateGroups()
    if (payload.status?.code === 200) {
      const corporateGroupList: { value: string; label: string }[] = []
      payload.data.map((group) => {
        corporateGroupList.push({ value: group._id, label: group.name })
      })
      setCorporateGroup(corporateGroupList)
    }
  }

  const findAddress = async () => {
    const payload = await getAddress()
    if (payload.status?.code === 200) {
      setAddress(payload.data)
    }
  }
  const validateNameList = [
    ['corporateName', 'th'],
    ['corporateName', 'en'],
    'taxId',
    'initial',
    'corporateNumber',
    'phoneNumber',
    'email',
    'streetAddress1',
    'streetAddress2',
    'province',
    'district',
    'subdistrict',
    'postalCode',
    'corporateGroup',
    'corporateType',
  ]
  const handleSaveChanges = async () => {
    try {
      const formValue = await form.validateFields(validateNameList)
      if (formValue) {
        form.setFieldsValue({
          initial: formValue.initial || null,
          phoneNumber: formValue.phoneNumber || null,
          streetAddress2: formValue.streetAddress2 || null,
        })
        form.submit()
      }
    } catch (err: any) {
      form.scrollToField(err?.errorFields[0]?.name, { behavior: 'smooth' })
    }
  }

  const handleChangeProvince = (provinceName) => {
    const findProvince = address.find((f) => f.name_th === provinceName)
    if (findProvince) {
      setDistricts(findProvince.districts)
      setSubDistricts([])
      form.resetFields(['district', 'subdistrict', 'postalCode'])
    }
  }

  const handleChangeDistrict = (districtName) => {
    const findDistrict = districts.find((f) => f.name_th === districtName)
    if (findDistrict) {
      setSubDistricts(findDistrict.subdistricts)
      form.resetFields(['subdistrict', 'postalCode'])
    }
  }

  const handleChangeSubDistrict = (subDistrictName) => {
    const findSubDistrict = subDistricts.find((f) => f.name_th === subDistrictName)
    if (findSubDistrict) {
      form.setFieldValue('postalCode', findSubDistrict.postcode)
    }
  }

  const disabled = useMemo(() => {
    return corporateId ? true : false
  }, [corporateId])
  return (
    <>
      <ContentPanel title='Corporate Details'>
        <Row gutter={16}>
          <Col span={24}>
            <div className='text-lg font-bold mb-3'>ชื่อ/ชื่อบริษัท</div>
          </Col>
          <Col span={24}>
            <Form.Item
              name={['corporateName', 'th']}
              rules={[{ required: true, message: 'please input corporate name in Thai' }]}
            >
              <Input size='large' placeholder='ภาษาไทย *' />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name={['corporateName', 'en']}
              rules={[{ required: true, message: 'please input corporate name in English' }]}
            >
              <Input size='large' placeholder='English *' />
            </Form.Item>
          </Col>
          <Col span={24}>
            <div className='text-lg font-bold mb-3'>ข้อมูลเพิ่มเติม</div>
          </Col>
          <Col span={24}>
            <Form.Item name={'taxId'} rules={[{ required: true, message: 'please input tax id' }]}>
              <Input size='large' placeholder='เลขประจำตัวผู้เสียภาษี *' disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name={'corporateNumber'}
              rules={[{ required: true, message: 'please input vendor code (corporate number)' }]}
            >
              <Input
                size='large'
                placeholder='Vendor Code (Corporate Number) *'
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name={'initial'} rules={[{ required: false }]}>
              <Input size='large' placeholder='ชื่อย่อ' />
            </Form.Item>
          </Col>
          <Col span={24}>
            <div className='text-lg font-bold mb-3'>ข้อมูลการติดต่อ</div>
          </Col>
          <Col span={12}>
            <Form.Item name={'phoneNumber'} rules={[{ required: false }]}>
              <Input size='large' placeholder='เบอร์ติดต่อ' />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={'email'}
              rules={[
                { required: true, message: 'please input email' },
                { type: 'email', message: 'The input is not valid email!' },
              ]}
            >
              <Input size='large' placeholder='อีเมล *' />
            </Form.Item>
          </Col>
          <Col span={24}>
            <div className='text-lg font-bold mb-3'>ที่อยู่</div>
          </Col>
          <Col span={24}>
            <Form.Item
              name={'streetAddress1'}
              rules={[{ required: true, message: 'please input address' }]}
            >
              <Input className='w-full' size='large' placeholder='ที่อยู่ *' />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name={'streetAddress2'} rules={[{ required: false }]}>
              <Input className='w-full' size='large' placeholder='ที่อยู่เพิ่มเติม' />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={'province'}
              rules={[{ required: true, message: 'please select province' }]}
            >
              <Select
                className='w-full'
                size='large'
                placeholder='จังหวัด *'
                onChange={handleChangeProvince}
                showSearch
                optionFilterProp='children'
              >
                {address?.length &&
                  address.map((item) => {
                    return (
                      <Option key={item.id} value={item.name_th}>
                        {item.name_th}
                      </Option>
                    )
                  })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={'district'}
              rules={[{ required: true, message: 'please select district' }]}
            >
              <Select
                className='w-full'
                size='large'
                placeholder='เขต/อำเภอ *'
                onChange={handleChangeDistrict}
                showSearch
                optionFilterProp='children'
                disabled={!districts.length}
              >
                {districts?.length &&
                  districts.map((item: any) => {
                    return (
                      <Option key={item.id} value={item.name_th}>
                        {item.name_th}
                      </Option>
                    )
                  })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={'subdistrict'}
              rules={[{ required: true, message: 'please select subdistrict' }]}
            >
              <Select
                className='w-full'
                size='large'
                placeholder='แขวง/ตำบล *'
                onChange={handleChangeSubDistrict}
                showSearch
                optionFilterProp='children'
                disabled={!subDistricts.length}
              >
                {subDistricts?.length &&
                  subDistricts.map((item: any) => {
                    return (
                      <Option key={`subdistrict-${item.id}`} value={item.name_th}>
                        {item.name_th}
                      </Option>
                    )
                  })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={'postalCode'}
              rules={[{ required: true, message: 'please select postalCode' }]}
            >
              <Input className='w-full' size='large' placeholder='รหัสไปรษณีย์ *' />
            </Form.Item>
          </Col>
        </Row>
      </ContentPanel>
      <ContentPanel title='กลุ่มลูกค้า'>
        <Form.Item
          name={'corporateGroup'}
          className='m-0'
          rules={[{ required: true, message: 'please select corporate group' }]}
        >
          <Select
            className='w-full'
            size='large'
            placeholder='กลุ่ม *'
            options={corporateGroup}
            automate-test='select-corporate-group'
          />
        </Form.Item>
      </ContentPanel>
      <ContentPanel title='ประเภท'>
        <Form.Item
          name={'corporateType'}
          className='m-0'
          rules={[{ required: true, message: 'please select corporate type' }]}
        >
          <Select
            className='w-full'
            size='large'
            placeholder='ประเภท *'
            options={[
              { value: 'CORPORATE', label: 'Corporate' },
              { value: 'PERSONAL', label: 'Personal' },
            ]}
            automate-test='select-corporate-type'
          />
        </Form.Item>
      </ContentPanel>
      <div className='mt-10 flex gap-2 justify-end'>
        <Button
          type='primary'
          size='large'
          onClick={handleSaveChanges}
          automate-test='btn-save-corporate'
        >
          {'Save Changes'}
        </Button>
      </div>
    </>
  )
}

export default FormManageCorporate
